import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { SocketProvider } from "./context/SocketContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import ChatPage from "./pages/ChatPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyOtp from "./pages/VerifyOtp";
import { useEffect } from "react";
import useAuthStore from "./store/authStore";
import useChatStore from "./store/chatStore";
import OnlineNotification from "./components/chat/OnlineNotification";

// Ping backend immediately on app load to wake up Render free tier
(function wakeUpBackend() {
  const url = (process.env.REACT_APP_API_URL || "http://localhost:5000/api").replace("/api", "");
  fetch(url + "/api/health", { method: "GET" }).catch(() => {});
})();

const App = () => {
  const { user } = useAuthStore();
  const { unreadCounts, mutedConversations } = useChatStore();

  useEffect(() => {
    const total = Object.entries(unreadCounts || {}).reduce((acc, [convId, count]) => {
      const isMuted = (mutedConversations || []).includes(convId);
      return acc + (isMuted ? 0 : (count || 0));
    }, 0);
    document.title = total > 0 ? `(${total}) Chatify 💬` : "Chatify 💬";
  }, [unreadCounts, mutedConversations]);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <SocketProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "13px",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
              },
              success: { iconTheme: { primary: "#7c3aed", secondary: "white" } },
            }}
          />
          {user && <OnlineNotification />}
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/login"
              element={user ? <Navigate to="/" replace /> : <Login />}
            />
            <Route
              path="/register"
              element={user ? <Navigate to="/" replace /> : <Register />}
            />
            <Route path="/verify-otp" element={<VerifyOtp mode="email" />} />
            <Route path="/verify-2fa" element={<VerifyOtp mode="2fa" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SocketProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
